import { queryClient } from "@/app/state/query-client";

export const invalidator = () => {
  return {
    byEntity: (entityName: string) =>
      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey?.[0] === entityName,
      }),
  };
};

/**
 * Company-scoped queries carry `{ companyId }` as the second element of their
 * key. That is what lets one company's entries be told apart and removed.
 */
export const discardCompanyQueries = (companyId: number) =>
  queryClient.removeQueries({
    predicate: (query) =>
      (query.queryKey[1] as { companyId?: unknown } | undefined)?.companyId ===
      companyId,
  });
